const ShowPromoteSvg = () => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" fill="none"><path fill="#A7C9F0" d="M7 0C4.325 0 1.9 1.463.11 3.84a.554.554 0 0 0 0 .662C1.9 6.882 4.325 8.345 7 8.345s5.1-1.463 6.89-3.84a.554.554 0 0 0 0-.662C12.1 1.463 9.675 0 7 0Zm.192 7.111a2.946 2.946 0 0 1-3.13-3.13 2.951 2.951 0 0 1 2.746-2.747 2.946 2.946 0 0 1 3.13 3.13 2.96 2.96 0 0 1-2.746 2.747Zm-.089-1.357A1.583 1.583 0 0 1 5.42 4.07c.049-.79.69-1.43 1.48-1.481a1.583 1.583 0 0 1 1.685 1.684 1.592 1.592 0 0 1-1.48 1.48Z"/></svg>
  )
}

export default ShowPromoteSvg;